<div class="gc-email-widget column-flex-container bc-work-item-theme {{cssClassName$ | async}}"
  [attr.data-automation-id]="'gc-email-widget'">

  <app-genesys-email-widget-header
    [externalContactFullName]="externalContactFullName$ | async"
    [name]="name$ | async"
    [isExpandedMode]="isExpandedMode()"
    [integrations]="integrations$ | async"
    [openIntegrationPanels]="openIntegrationPanels$ | async"
    [isProactiveEmail]="isEmptyProactiveEmail$ | async"
    (minimize)="onMinimize()"
    (toggleExpanded)="onToggleExpanded()"
    (toggleIntegration)="onToggleIntegration($event)">
  </app-genesys-email-widget-header>

  <div class="bc-layout-wrapper email-widget-content column-flex-grow panel-shadow-wrapper multilane-wrapper" *ngIf="(isLoading$ | async) === false; else isLoadingTmplt">
    <div class="column-flex-container multilane-item"
      [ngClass]="{ 'multilane-item-1': !isExpandedMode(), 'multilane-item-2': isExpandedMode() }">

      <app-genesys-email-box
        [conversationId]="conversationId$ | async"
        [lastEmailMessage]="lastEmail$ | async"
        [themeClass]="cssClassName$ | async"
        [isLastEmailFromCustomer] = "isLastEmailFromCustomer$ | async"
        [isProactiveEmail]="isEmptyProactiveEmail$ | async"
        [agentEmailAddress]="agentEmailAddress$ | async"
        [customerEmailAddresses]="customerEmailAddresses$ | async"
        [isExpanded]="isExpandedMode()"
        [draftEmail]="draftEmail$ | async"
        [agentParticipantId]="agentParticipantId$ | async"
        [emailError]="emailError$ | async"
        [isWrapUpRequired]="isWrapUpRequired$ | async"
        >
      </app-genesys-email-box>

    </div>

    <ng-container *ngFor="let integration of openIntegrationPanels$ | async">
      <div [hidden]="!isExpandedMode()"
        class="multilane-item multilane-item-1 integration-panel bc-work-lane bc-panel">
          <app-genesys-integration-panel
            [integration]="integration"
            [conversation]="conversation$ | async">
          </app-genesys-integration-panel>
      </div>
    </ng-container>
  </div>

  <ng-template #isLoadingTmplt>
    <app-loading heading="bcLoading.loadingText"></app-loading>
  </ng-template>
</div>
